<script setup lang="ts">
import Modal from '@/components/modals/Modal.vue'
import useModal from '@/composables/useModal'
import { useI18n } from 'vue-i18n'
import useSyncConfiguration, { isSyncNotification } from '@/composables/useSyncConfiguration'
import { SaiftyNotification } from '@/config'

interface Props {
  data: SaiftyNotification
}

const props = defineProps<Props>()

const { modal, openModal, hideModal } = useModal()
const { t } = useI18n()
const { isSyncActionLoading, addSyncItemIntoSkipList, getSyncSkipListModalFields } = useSyncConfiguration()

defineExpose({
  openModal,
})
</script>

<template>
  <Modal
    v-if="isSyncNotification(props.data.data)"
    id="addItemToSkipList"
    ref="modal"
    size="xl"
    :title="t('Add item into the Skiplist')"
    border-classes="rounded-15 shadow-lg"
    body-classes="p-4 m-3 text-black"
    new-style
    desactivate-backdrop
  >
    <h5 for="skiplist" class="mt-4 mb-3 w-100 text-center fw-bold">{{ t('Item data') }}</h5>
    <div style="max-height: 32rem; overflow-x: hidden">
      <div v-for="(item, index) in getSyncSkipListModalFields(props.data)" :key="index" class="row">
        <strong class="col-2 pe-0">{{ item.title }}</strong>
        <p class="col-10 ps-0 pe-4">{{ item.value }}</p>
      </div>
    </div>

    <div class="w-100 d-flex justify-content-end mt-5">
      <button class="btn btn-danger rounded-pill px-4 ms-3 fw-normal" @click="hideModal">
        <span>
          {{ t('Cancel') }}
        </span>
      </button>
      <button
        class="btn btn-primary rounded-pill px-4 ms-3 d-flex fw-normal"
        :disabled="isSyncActionLoading"
        @click="addSyncItemIntoSkipList(props.data.data, hideModal)"
      >
        {{ t('Add to Skiplist') }}
        <Loading v-if="isSyncActionLoading" extra-classes="mt-0 ms-2" size="sm" />
      </button>
    </div>
  </Modal>
</template>
